import { FlexBoxCenteredLayout } from '../../../common/layout/flex-box'
import { Outlet } from '../../../common/Outlet'

export const PurchaseSourcePage = () => {
  return (
    <FlexBoxCenteredLayout>
      <Outlet />
    </FlexBoxCenteredLayout>
  )
}
